import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getViewProfile,
  updateProfile,
} from "../../../redux/slices/profileSlice";
import {
  activityStart,
  activityEnd,
} from "../../../redux/slices/trackActivitySlice";

const ShiftTypeModal = ({ show, onHide }) => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);

  const [selectedShift, setSelectedShift] = useState("");
  const [error, setError] = useState("");

  const shiftOptions = [
    { id: "day", label: "Day Shift" },
    { id: "night", label: "Night Shift" },
    { id: "evening", label: "Evening Shift" },
    { id: "rotating", label: "Rotating Shift" },
    { id: "flexible", label: "Flexible Shift" },
  ];

  useEffect(() => {
    if (store?.profileItem?.data?.preferred_shift_type) {
      setSelectedShift(store.profileItem.data.preferred_shift_type);
    }
  }, [store?.profileItem]);

  const handleSave = () => {
    if (!selectedShift) {
      setError("Please select a shift type");
      return;
    }

    const payload = {
      name: store?.profileItem?.data?.full_name,
      preferred_shift_type: selectedShift,
    };

    dispatch(updateProfile(payload));
  };

  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
    }
  }, [store?.actionFlag, onHide]);
  useEffect(() => {
    if (!show) return;

    // Modal opened — start a tracking session
    dispatch(activityStart({ page_name: "CHANGE_SHIFT_TYPE", platform: "web" }));

    return () => {
      // Modal closed — end the session (duration recorded in seconds)
      dispatch(activityEnd({ page_name: "CHANGE_SHIFT_TYPE" }));
    };
  }, [show, dispatch]);
  useEffect(() => {
    if (show) {
      // dispatch(getViewProfile());
    }
  }, [show, dispatch]);
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">Preferred Shift Type</h5>
        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className="radio-options">
          <div className="row">
            {shiftOptions.map((shift) => (
              <div
                key={shift.id}
                className={`radio-option col-lg-6 ${
                  selectedShift === shift.id ? "selected" : ""
                }`}
                onClick={() => {
                  setSelectedShift(shift.id);
                  setError("");
                }}
              >
                <div className="contentwrap">
                  <input
                    type="radio"
                    name="shift"
                    value={shift.id}
                    checked={selectedShift === shift.id}
                    onChange={() => {
                      setSelectedShift(shift.id);
                      setError("");
                    }}
                  />

                  <span className="radio-label">{shift.label}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {error && <div className="error-message mt-2">{error}</div>}

        <div className="text-center mt-4">
          <Button
            className="btn-primary px-4"
            onClick={handleSave}
            disabled={store?.isLoading || !selectedShift}
          >
            {store?.isLoading ? "Saving..." : "Save"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ShiftTypeModal;
